import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/CreditCardMarketingBanner/GET';

export const CREDIT_CARD_MARKETING_BANNER_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const CREDIT_CARD_MARKETING_BANNER_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
